import { Component, OnDestroy, OnInit } from '@angular/core';
import { ExitFormModel } from './exit-form.model';
import { MasterDataService } from '../../services/master-data.service';
import * as moment from 'moment';
import { CommonMessageService } from '../../services/common-message.service';
import { ExitFormService } from '../../services/exit-form.service';
import { Subscription } from 'rxjs';
import { HumanResourceService } from '../../services/human-resource.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-exit-form',
  templateUrl: './exit-form.component.html',
  styleUrls: ['./exit-form.component.css']
})
export class ExitFormComponent implements OnInit {
  exitFormModel: ExitFormModel;
  empFirstName;
  empLastName;
  empMiddleName;
  empID;
  partnerId;
  partnerFirstName;
  partnerMiddleName;
  partnerLastName;
  exitFormSubscription: Subscription;
  routeUrlName;
  currentDate;
  disableInterviewerFields;
  disableFieldsAfterEdit;

  constructor(private masterDataService: MasterDataService,
    private commonMessageService: CommonMessageService,
    private exitFormService: ExitFormService,
    private humanResourceService: HumanResourceService,
    private router: Router,
    private activatedroute: ActivatedRoute,
    private location:Location) {
    const current = new Date();
    this.currentDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
  }

  ngOnInit(): void {
    this.disableInterviewerFields = true;
    this.exitFormModel = new ExitFormModel();

    // this.exitFormModel = this.exitFormService.getExitForm();

    this.empFirstName = localStorage.getItem('userFname');
    this.empLastName = localStorage.getItem('userLname');
    this.empID = localStorage.getItem('id');
    this.exitFormModel.otherVoluntary = "";
    console.log('inside ngoninit', this.exitFormModel);
    this.routeUrlName = this.activatedroute.snapshot.routeConfig.path;
    console.log('routing id', this.routeUrlName);
    if (this.routeUrlName == 'exit-form') {
      this.userExitFormDetail();
      this.disableInterviewerFields = true;
      this.disableFieldsAfterEdit = false;
    }
    if (this.routeUrlName == 'exit-form-detail') {
      this.disableInterviewerFields = false;
      this.disableFieldsAfterEdit = true;
      this.loadPartnerList();
    }
  }

  partnerList;
  loadPartnerList() {
    this.humanResourceService.getLookupForManageProfile()
      .subscribe((res: any) => {
        this.partnerList = res.partners;
        this.getExitFormDetailFromSummary();
      });
  }
  onPartnerChange() {
    this.partnerId = this.exitFormModel.partner.id;
  }

  showArticleDataFromSummary: boolean;
  getExitFormDetailFromSummary() {
    this.exitFormModel = this.exitFormService.getExitForm();
    this.empFirstName = this.exitFormModel.user.firstName;
    this.empLastName = this.exitFormModel.user.lastName;
    this.empMiddleName = this.exitFormModel.user.middleName;
    this.empID = this.exitFormModel.user.id;
    this.partnerFirstName = this.exitFormModel.partner.firstName;
    this.partnerLastName = this.exitFormModel.partner.lastName;
    this.partnerMiddleName = this.exitFormModel.partner.middleName;
    this.partnerId = this.exitFormModel.partner.id;
    this.exitFormModel.user.droles.map((res) => {
      if (res.name == 'Article') {
        this.showArticleDataFromSummary = true;
      }
    });

    const partnerIndex = this.partnerList.findIndex((item) => item.id == this.exitFormModel.partner.id);
    this.exitFormModel.partner = this.partnerList[partnerIndex];

    if (this.exitFormModel.separationDate != null) {
      var seperationDate = new Date(this.exitFormModel.separationDate);
      this.selectedSeperationDate = { year: seperationDate.getFullYear(), month: seperationDate.getMonth() + 1, day: seperationDate.getDate() };
    } else {
      this.selectedSeperationDate = null;
    }

    if (this.exitFormModel.employeeSignatureDate != null) {
      var empSignDate = new Date(this.exitFormModel.employeeSignatureDate);
      this.selectedEmpSignDate = { year: empSignDate.getFullYear(), month: empSignDate.getMonth() + 1, day: empSignDate.getDate() };
    } else {
      this.selectedEmpSignDate = null;
    }

    if (this.exitFormModel.interviewerSignatureDate != null) {
      var interviewerSignDate = new Date(this.exitFormModel.interviewerSignatureDate);
      this.selectedInterviewerDate = { year: interviewerSignDate.getFullYear(), month: interviewerSignDate.getMonth() + 1, day: interviewerSignDate.getDate() };
    } else {
      this.selectedInterviewerDate = null;
    }

    console.log('before subscribe this.exitFormModelbefore subscribe this.exitFormModel', this.exitFormModel);
  }

  showSaveButton: boolean;
  userExitFormDetail() {
    this.masterDataService.getUserExitFormDetail().subscribe((resp: any) => {
      console.log('single user exit form detail', resp);
      if (resp.operationResult == 'not found') {
        this.showSaveButton = true;
      } else {
        if (resp.separationDate != null) {
          var seperationDate = new Date(resp.separationDate);
          this.selectedSeperationDate = { year: seperationDate.getFullYear(), month: seperationDate.getMonth() + 1, day: seperationDate.getDate() };
        } else {
          this.selectedSeperationDate = null;
        }

        if (resp.employeeSignatureDate != null) {
          var empSignDate = new Date(resp.employeeSignatureDate);
          this.selectedEmpSignDate = { year: empSignDate.getFullYear(), month: empSignDate.getMonth() + 1, day: empSignDate.getDate() };
        } else {
          this.selectedEmpSignDate = null;
        }

        if (resp.interviewerSignatureDate != null) {
          var interviewerSignDate = new Date(resp.interviewerSignatureDate);
          this.selectedInterviewerDate = { year: interviewerSignDate.getFullYear(), month: interviewerSignDate.getMonth() + 1, day: interviewerSignDate.getDate() };
        } else {
          this.selectedInterviewerDate = null;
        }

        this.empFirstName = resp.user.firstName;
        this.empLastName = resp.user.lastName;
        this.empMiddleName = resp.user.middleName;
        this.empID = resp.user.id;
        this.partnerFirstName = resp.partner.firstName;
        this.partnerLastName = resp.partner.lastName;
        this.partnerMiddleName = resp.partner.middleName
        this.exitFormModel = resp;
        this.partnerId = resp.partner.id;
      }
    });
  }

  selectedSeperationDate;
  onSeperationDateSelect() {
    var selectedSeperationDate1 = new Date(this.selectedSeperationDate.year + '-' + this.selectedSeperationDate.month + '-' + this.selectedSeperationDate.day);
    var selectedSeperationDate2 = moment(selectedSeperationDate1).format("YYYY-MM-DD");
    this.exitFormModel.separationDate = selectedSeperationDate2;
    console.log('selectedSeperationDate2 date', selectedSeperationDate2);
  }

  selectedEmpSignDate;
  onEmpSignDateSelect() {
    var selectedEmpSignDate1 = new Date(this.selectedEmpSignDate.year + '-' + this.selectedEmpSignDate.month + '-' + this.selectedEmpSignDate.day);
    var selectedEmpSignDate2 = moment(selectedEmpSignDate1).format("YYYY-MM-DD");
    this.exitFormModel.employeeSignatureDate = selectedEmpSignDate2;
    console.log('selectedEmpSignDate2 date', selectedEmpSignDate2);
  }

  selectedInterviewerDate;
  onInterviewerSignDateSelect() {
    var selectedInterviewerDate1 = new Date(this.selectedInterviewerDate.year + '-' + this.selectedInterviewerDate.month + '-' + this.selectedInterviewerDate.day);
    var selectedInterviewerDate2 = moment(selectedInterviewerDate1).format("YYYY-MM-DD");
    this.exitFormModel.interviewerSignatureDate = selectedInterviewerDate2;
    console.log('selectedInterviewerDate2 date', selectedInterviewerDate2);
  }

  saveClick() {
    console.log('exit form Model', this.exitFormModel);
    this.masterDataService.saveExitFormDetails(this.exitFormModel).subscribe(() => {
      this.commonMessageService.saveMessage();
    });
  }

  cancleClick() {
    const currentUrl = this.router.url;
    //  this.location.go(this.location.path());
// this.router.navigateByUrl('/',{skipLocationChange:true}).then(()=>{
//   this.router.navigateByUrl('dashboard/exit-form-summary');
// })
  }

  updateClick() {
    this.masterDataService.updateExitFormDetails(this.exitFormModel, this.empID, this.partnerId).subscribe(() => {
      this.commonMessageService.updateMessage();
      //this.router.navigateByUrl('dashboard/exit-form-summary');
      // this.cancleClick();
    })
  }
}
